import { CoreItem, CoreItemBackend } from '../core-item/core-item';

export interface ObjectionBackend extends CoreItemBackend {
  type: ObjectionType;

  unsafeSubData: ObjectionUnsafeSubData;
}

export interface Objection extends CoreItem {
  type: ObjectionType;

  unsafeSubData: ObjectionUnsafeSubData;
}

export enum ObjectionType {
  emotional = 'emotional',
  fact = 'fact',
}

export interface ObjectionUnsafeSubData {}
